import MasterTablePage from '../components/MasterTablePage';
import { listProductsPage, createProduct, updateProduct, deleteProduct, bulkUploadProducts } from '../api/products';

const columns = [
  { key: 'productCode', label: 'Code' },
  { key: 'productName', label: 'Name' },
  { key: 'category', label: 'Category' },
  { key: 'unit', label: 'Unit' },
];

const fields = [
  { name: 'productCode', label: 'Product Code' },
  { name: 'productName', label: 'Product Name' },
  { name: 'category', label: 'Category', required: false },
  { name: 'unit', label: 'Unit', required: false },
];

export default function ProductMaster() {
  return (
    <MasterTablePage
      title="Product Master"
      columns={columns}
      fields={fields}
      api={{
        list: listProductsPage,
        create: createProduct,
        update: updateProduct,
        remove: deleteProduct,
        bulkUpload: bulkUploadProducts,
      }}
      uploadTemplateHint="Columns: productCode, productName, category, unit"
    />
  );
}
